export default {
  lang: 'en',
  file: {
    wangEditor: {
      插入: 'Insert',
      默认: 'Default',
      创建: 'Create',
      修改: 'Edit',
      如: 'Like',
      请输入正文: 'Please enter the body',
      menus: {
        title: {
          标题: 'Title',
          加粗: 'Bold',
          字号: 'Trade name',
          字体: 'Font',
          斜体: 'Italics',
          下划线: 'Underline',
          删除线: 'Delete line',
          缩进: 'Indent',
          行高: 'Row height',
          文字颜色: 'Text color',
          背景色: 'Background color',
          链接: 'Link',
          序列: 'Sequence',
          对齐: 'Alignment',
          引用: 'Quote',
          表情: 'Expression',
          图片: 'Picture',
          视频: 'Video',
          表格: 'Table',
          代码: 'Code',
          分割线: 'Dividing line',
          恢复: 'Redo',
          撤销: 'Undo',
          全屏: 'Full screen',
          代办事项: 'To Do List'
        },
        dropListMenu: {
          设置标题: 'Set title',
          背景颜色: 'Background color ',
          文字颜色: 'Text color',
          设置字号: 'Set font size',
          设置字体: 'Set font',
          设置缩进: 'Set indent',
          对齐方式: 'Alignment',
          设置行高: 'Set row height',
          序列: 'Sequence',
          head: {
            正文: 'Text'
          },
          indent: {
            增加缩进: 'Increase Indent',
            减少缩进: 'Decrease indent'
          },
          justify: {
            靠左: 'Left',
            居中: 'Center',
            靠右: 'Right'
          },
          list: {
            无序列表: 'Unordered list',
            有序列表: 'Ordered list'
          }
        },
        panelMenus: {
          emoticon: {
            默认: 'Default',
            新浪: 'sina',
            emoji: 'emoji',
            手势: 'Gesture'
          },
          image: {
            图片链接: 'Pictures linking',
            上传图片: 'Upload pictures',
            网络图片: 'Internet pictures'
          },
          link: {
            链接: 'Link',
            链接文字: 'Link text',
            删除链接: 'Delete link',
            查看链接: 'View links'
          },
          video: {
            插入视频: 'Insert video'
          },
          table: {
            行: 'Row',
            列: 'Column',
            的: 'Of',
            表格: 'Table',
            添加行: 'Add rows',
            删除行: 'Delete row',
            添加列: 'Add column',
            删除列: 'Delete column',
            设置表头: 'Set the header',
            取消表头: 'Cancel header',
            插入表格: 'Insert table',
            删除表格: 'Delete form'
          },
          code: {
            删除代码: 'Delete code',
            修改代码: 'Modify the code',
            插入代码: 'Insert code'
          }
        }
      },
      validate: {
        张图片: 'Picture',
        大于: 'bigger than',
        图片链接: 'pictures linking',
        不是图片: "It's not a picture",
        返回结果: 'Return results',
        上传图片超时: 'Upload image timeout',
        上传图片错误: 'Upload image error',
        上传图片失败: 'Failed to upload picture',
        插入图片错误: 'Insert picture error',
        一次最多上传: 'Up to one upload',
        下载链接失败: 'Failed to download link',
        图片验证未通过: 'Picture verification failed',
        服务器返回状态: 'Server return status',
        上传图片返回结果错误: 'Error in result of uploading picture',
        请替换为支持的图片类型: 'Please replace with a supported picture type',
        您插入的网络图片无法识别:
          'The network picture you inserted is not recognized',
        您刚才插入的图片链接未通过编辑器校验:
          'The picture link you just inserted did not pass the editor verification'
      }
    }
  }
}
